import { Form, Space, Button, Input } from 'antd';
import { useEffect } from 'react';
import api from '../utils/apiClient';
import TenantAdminSelector from './TenantAdminSelector';
import TenantUsersTable from './TenantUsersTable';

const TenantForm = ({ tenant, onSuccess, onCancel }) => {
  const [form] = Form.useForm();
  const isEdit = !!tenant;

  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue(tenant);
    } else {
      form.resetFields();
    }
  }, [tenant, isEdit, form]);

  const handleFinish = async (values) => {
    try {
      const url = isEdit ? `/tenants/${tenant.tenant_id}` : '/tenants';
      const method = isEdit ? 'put' : 'post';
      if (!isEdit && values.tenant_admin) {
        // When UserForm creates an admin user, it doesn't actually persist it,
        // but it does add user_id to keep the components happy, so it's better to
        // remove it before sending this stuff to the server
        delete values.tenant_admin.user_id;
      }
      await api[method](url, values);
      onSuccess();
    } catch (err) {
      console.error('Error saving tenant', err);
    }
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 },
    },
  };
  const isRootTenant = !!tenant && tenant.tenant_id === 'scatr';

  return (
    <Form
      {...formItemLayout}
      form={form}
      layout="horizontal"
      variant="outlined"
      onFinish={handleFinish}>

      <Form.Item name="name" label="Tenant Name" rules={[{ required: true }]}>
        <Input disabled={isRootTenant} />
      </Form.Item>

      <Form.Item name="tenant_admin" label="Tenant Admin">
        <TenantAdminSelector
          value={form.getFieldValue('tenant_admin')}
          tenantId={tenant?.tenant_id}
          onChange={(val) => form.setFieldsValue({ tenant_admin: val })}
        />
      </Form.Item>

      <Form.Item label="Tenant Users">
        <TenantUsersTable
          tenantId={tenant?.tenant_id}
          users={tenant?.users || []}
          onChange={(val) => form.setFieldsValue({ users: val })}
        />
      </Form.Item>

      <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button type="primary" htmlType="submit" disabled={isRootTenant}>
          {isEdit ? 'Update' : 'Create'}
        </Button>
      </Space>
    </Form>
  );
};

export default TenantForm;
